import { render, staticRenderFns } from "./knowledge_base.vue?vue&type=template&id=aaf10182&scoped=true&"
import script from "./knowledge_base.vue?vue&type=script&lang=js&"
export * from "./knowledge_base.vue?vue&type=script&lang=js&"
import style0 from "./knowledge_base.vue?vue&type=style&index=0&id=aaf10182&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aaf10182",
  null
  
)

export default component.exports